module.exports = __webpack_public_path__ + "img/energy-banner.934ea6fc.png";